import { render, staticRenderFns } from "./formButton.vue?vue&type=template&id=ce2ca718&"
import script from "./formButton.vue?vue&type=script&lang=js&"
export * from "./formButton.vue?vue&type=script&lang=js&"
import style0 from "./formButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports